import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
    galleryList,
    getOneGallery,
    addEditGallery,
    uploadedImage,
    deleteGallery
} from "../../Redux/Slices/gallerySlice";
import moment from "moment";
import { Formik, Form, Field } from "formik";
import toast from "react-hot-toast";
import ClipLoader from "react-spinners/ClipLoader";
import { Paginator } from "primereact/paginator";
import DeleteModal from "../../Components/DeleteModal";

const Gallery = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [tableData, setTableData] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [uploadedImageUrls, setUploadedImageUrls] = useState([]);
    // const [userType, setuserType] = useState([]);
    const [sendMessage, setSendMessgae] = useState([]);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [limit, setLimit] = useState(3);
    const [first, setFirst] = useState(0);
    const [pagination, setPaginationData] = useState(0);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);


    const initialValues = {
        photoId: "",
        subject: "",
        message: "",
        date: "",
        fromdate: "",
        todate: "",
        photo: [],
    };

    const getGalleryListFun = async (event = {}) => {
        let pageNo = event?.page || 0;
        let currentLimit = event?.rows || limit;
        
        try {
            setLoading(true);
            const payload = {
                page: pageNo + 1,
                limit: currentLimit,
                search: searchValue || "",
                fromDate: fromDate || "",
                toDate: toDate || "",
            };
            const response = await dispatch(galleryList(payload)).unwrap();
            setTableData(response.Data.docs);
            setPaginationData(response.Data.totalDocs);   
            setFirst(pageNo * currentLimit);
            setLoading(false);
        } catch (error) {
            console.log("error :>> ", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const handleImageUpload = async (event) => {
        const files = Array.from(event.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                setUploadedImages((prev) => [...prev, e.target.result ]);
            };
            reader.readAsDataURL(file);
        });
        try {
            setIsUploading(true); // Start loader
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("photo", file);
            });
            const result = await dispatch(uploadedImage(formData)).unwrap();

            if (result.IsSuccess) {
                const newImageUrls = Array.isArray(result.Data)
                    ? result.Data
                    : [result.Data];
                setUploadedImageUrls((prev) => [...prev, ...newImageUrls]);
            } else {
                toast.error("Failed to upload images");
            }
        } catch (error) {
            console.error("Error uploading images:", error);
            toast.error("Error uploading images");
        } finally {
            setIsUploading(false);
        }
    };

    const fetchSendMessage = async (id) => {
        try {
            const response = await dispatch(getOneGallery({ photoId: id })).unwrap();
            if (response.IsSuccess) {
                setSendMessgae(response.Data || []);
                setSelectedMessage({
                    photoId: response.Data._id || "",
                    subject: response.Data.subject || "",
                    message: response.Data.message || "",
                    date: response.Data.date ? moment(response.Data.date, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                    fromdate: response.Data.fromdate ? moment(response.Data.fromdate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                    todate: response.Data.todate ? moment(response.Data.todate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                    photo: response.Data.photo || [],
                });
                setUploadedImageUrls(response.Data.photo.map(image => image) || []);
                setUploadedImages(response.Data.photo.map(image => image.photo) || []);
            } else {
                searchValue(initialValues);
                setUploadedImages([]);
                setUploadedImageUrls([]);
            }
        } catch (error) {
            console.error("Error fetching message:", error);
            toast.error("Failed to fetch Message details");
        }
    };

    const handleSubmit = async (values, { resetForm }) => {
        if (values.subject === "" || values.message === "") {
            toast.error("Form data is missing.");
            return;
        }
        if (!uploadedImageUrls || uploadedImageUrls.length === 0) {
            toast.error("Please upload at least one image");
            return;
        }
        
        try {
            setLoading(true);
            const payload = {
                photoId: values.photoId || "",
                subject: values.subject || "",
                message: values.message || "",
                date: values.date ? moment(values.date).format("DD-MM-YYYY") : "",
                fromDate: values.fromdate ? moment(values.fromdate).format("DD-MM-YYYY") : "",
                toDate: values.todate ? moment(values.todate).format("DD-MM-YYYY") : "",
                photo: uploadedImageUrls.map(photo => photo)
            };
            const response = await dispatch(addEditGallery(payload)).unwrap();
            if (response.IsSuccess) {
                toast.success(response.Message);
                resetForm();
                setSelectedMessage(null);
                setUploadedImages([]);
                setUploadedImageUrls([]);
                getGalleryListFun();
            } else {
                toast.error(
                    response.Message || "Something went wrong. Please try again."
                );
            }
        } catch (error) {
            console.error("Error submitting form: ", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getGalleryListFun();
    }, [searchValue, fromDate, toDate]);

    const handleDeleteClick = (id) => {
        setIdToDelete(id);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await dispatch(deleteGallery({ photoId: idToDelete || "" })).unwrap();
            toast.success(response.Message);
            getGalleryListFun();
            setTableData((prevData) => prevData.filter((item) => item._id !== idToDelete)); // Remove from UI
        } catch (error) {
            console.error("Error deleting message:", error);
        } finally {
            setIsDeleteModalOpen(false);
            setIdToDelete(null);
        }
    };
    return (
        <>
            <div className="flex flex-wrap p-6">
                <div className="w-full lg:w-[calc(100%-370px)] p-3.5">
                    <Formik
                        initialValues={selectedMessage || initialValues}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {({ values }) => (
                            <Form className="p-7 bg-white rounded-xl shadow-custom_shadow_2 space-y-3">
                                <div className="w-full">
                                    <Field
                                        type="text"
                                        name="subject"
                                        className="text-18 lg:text-20 py-3 lg:py-5 px-7 rounded-xl w-full bg-secondary text-text_2 outline-none"
                                        placeholder="Subject"
                                    />
                                </div>
                                <div className="flex gap-4">
                                    <div className="w-full lg:w-1/2">
                                        <label className="text-14 text-text_2 mb-1 block">From Date</label>
                                        <Field
                                            type="date"
                                            id="fromdate"
                                            name="fromdate"
                                            className="text-16 lg:text-18 py-3 lg:py-4 px-7 rounded-xl w-full bg-secondary text-text_2 outline-none"
                                        />
                                    </div>
                                    <div className="w-full lg:w-1/2">
                                        <label className="text-14 text-text_2 mb-1 block">To Date</label>
                                        <Field
                                            type="date"
                                            id="todate"
                                            name="todate"
                                            className="text-16 lg:text-18 py-3 lg:py-4 px-7 rounded-xl w-full bg-secondary text-text_2 outline-none"
                                        />
                                    </div>
                                </div>
                                <div className="w-full">
                                    <Field
                                        type="date"
                                        id="date"
                                        name="date"
                                        className="text-18 lg:text-20 py-3 lg:py-5 px-7 rounded-xl w-full bg-secondary text-text_2 outline-none"
                                    >
                                    </Field>
                                </div>
                                <div className="w-full bg-secondary rounded-2xl">
                                    <div className="relative border-2 border-dashed border-gray_2 rounded-xl">
                                        <input
                                            type="file"
                                            name="upload_image"
                                            id="upload_image"
                                            className="cursor-pointer absolute w-full h-full opacity-0 inset-0"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageUpload}
                                        />
                                        <div className="flex justify-center items-center space-x-2 py-4 pl-2">
                                            <div className="flex items-center justify-center">
                                                <span className="w-12 h-12 rounded-full bg-white flex items-center justify-center">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clipPath="url(#clip0_1_18031)">
                                                            <path d="M16.2657 5.59703C16.0518 4.32621 15.4226 3.16644 14.4602 2.28632C13.3909 1.3075 12.0008 0.768738 10.5532 0.768738C9.43451 0.768738 8.34464 1.08953 7.41106 1.69409C6.63377 2.19584 5.98807 2.87443 5.53157 3.6723C5.33416 3.63528 5.12852 3.61472 4.92289 3.61472C3.17499 3.61472 1.752 5.03771 1.752 6.7856C1.752 7.0118 1.77668 7.22977 1.81781 7.44363C0.686819 8.26617 0 9.59045 0 11.0011C0 12.1403 0.423607 13.2466 1.19679 14.1226C1.99054 15.0192 3.03928 15.5497 4.15793 15.6114C4.17027 15.6114 4.17849 15.6114 4.19083 15.6114H7.72774C8.03619 15.6114 8.28295 15.3647 8.28295 15.0562C8.28295 14.7478 8.03619 14.501 7.72774 14.501H4.20728C2.52519 14.3982 1.11043 12.7984 1.11043 10.997C1.11043 9.8331 1.73555 8.74735 2.74316 8.15924C2.97759 8.02352 3.07629 7.73974 2.98581 7.48476C2.90356 7.26267 2.86243 7.02825 2.86243 6.77738C2.86243 5.64227 3.78779 4.71692 4.92289 4.71692C5.16554 4.71692 5.40407 4.75805 5.62616 4.8403C5.89759 4.939 6.19782 4.81562 6.3212 4.55652C7.09027 2.92379 8.7518 1.87094 10.5573 1.87094C12.9838 1.87094 14.9866 3.68875 15.2169 6.09878C15.2416 6.34966 15.4308 6.55118 15.6776 6.5923C17.5077 6.90487 18.8896 8.59518 18.8896 10.524C18.8896 12.568 17.2815 14.3447 15.2992 14.4969H12.2681C11.9597 14.4969 11.7129 14.7437 11.7129 15.0521C11.7129 15.3606 11.9597 15.6073 12.2681 15.6073H15.3198C15.3321 15.6073 15.3444 15.6073 15.3609 15.6073C16.6153 15.5168 17.7874 14.9411 18.6593 13.9787C19.527 13.0245 20 11.799 20 10.524C19.9959 8.21682 18.4207 6.16458 16.2657 5.59703Z" fill="#3E4095" />
                                                            <path d="M13.3341 11.5218C13.5521 11.3039 13.5521 10.9543 13.3341 10.7363L10.3935 7.79573C10.2907 7.69292 10.1468 7.63123 10.0028 7.63123C9.85887 7.63123 9.71493 7.6888 9.61211 7.79573L6.67154 10.7363C6.45356 10.9543 6.45356 11.3039 6.67154 11.5218C6.77847 11.6288 6.92241 11.6863 7.06224 11.6863C7.20207 11.6863 7.34602 11.6329 7.45295 11.5218L9.4476 9.52718V18.6944C9.4476 19.0028 9.69436 19.2496 10.0028 19.2496C10.3113 19.2496 10.558 19.0028 10.558 18.6944V9.52718L12.5527 11.5218C12.7665 11.7398 13.1161 11.7398 13.3341 11.5218Z" fill="#3E4095" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_1_18031">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>
                                            </div>
                                            <span className="text-14 lg:text-16 text-text_2 block">Click Here to Upload Photos & Videos</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap">
                                        {isUploading && (
                                            <div className="flex justify-center items-center py-3 pl-3">
                                                <ClipLoader color="#286ab0" size={30} />
                                                <span className="ml-2 text-gray-500 font-bold">Uploading...</span>
                                            </div>
                                        )}
                                        {!isUploading && uploadedImages.map((img, index) => (
                                            <div key={index} className="w-[calc(100%/3)] md:w-[calc(100%/5)] xl:w-[calc(100%/7)] p-2">
                                                <div className="h-auto bg-white rounded-md relative">
                                                    <img src={img} alt={`Uploaded ${index + 1}`} className="w-full h-full object-cover rounded-md" />
                                                    <button
                                                        onClick={() => {
                                                            // event.stopPropagation();
                                                            setUploadedImages(prev => prev.filter((_, i) => i !== index));
                                                            setUploadedImageUrls(prev => prev.filter((_, i) => i !== index));
                                                        }}
                                                        className="absolute top-2 lg:top-1 right-2 lg:right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                                    >
                                                        <span className="bg-black rounded p-1 lg:p-0.5 ">
                                                            <svg className="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M15.865 10.7014L16.5336 10.7944L15.865 10.7014ZM15.6289 12.3979L16.2975 12.4909L15.6289 12.3979ZM4.3704 12.3979L5.03894 12.3048L4.3704 12.3979ZM4.1343 10.7014L3.46576 10.7944L4.1343 10.7014ZM7.465 18.7628L7.20257 19.3847L7.465 18.7628ZM5.02734 15.904L5.66091 15.6712L5.02734 15.904ZM14.972 15.904L15.6056 16.1368V16.1368L14.972 15.904ZM12.5343 18.7628L12.2719 18.1409L12.5343 18.7628ZM4.37175 7.23604C4.33648 6.86493 4.00705 6.59266 3.63594 6.62792C3.26483 6.66318 2.99257 6.99261 3.02783 7.36373L4.37175 7.23604ZM16.9715 7.36373C17.0068 6.99262 16.7345 6.66319 16.3634 6.62792C15.9923 6.59266 15.6629 6.86492 15.6276 7.23604L16.9715 7.36373ZM17.1995 6.1749C17.5723 6.1749 17.8745 5.8727 17.8745 5.49992C17.8745 5.12713 17.5723 4.82493 17.1995 4.82493V6.1749ZM2.7998 4.82493C2.42702 4.82493 2.12482 5.12713 2.12482 5.49992C2.12482 5.8727 2.42702 6.1749 2.7998 6.1749V4.82493ZM7.52472 15.3997C7.52472 15.7725 7.82692 16.0747 8.1997 16.0747C8.57249 16.0747 8.87469 15.7725 8.87469 15.3997H7.52472ZM8.87469 8.19986C8.87469 7.82708 8.57249 7.52488 8.1997 7.52488C7.82692 7.52488 7.52472 7.82708 7.52472 8.19986H8.87469ZM11.1247 15.3997C11.1247 15.7725 11.4269 16.0747 11.7996 16.0747C12.1724 16.0747 12.4746 15.7725 12.4746 15.3997H11.1247ZM12.4746 8.19986C12.4746 7.82708 12.1724 7.52488 11.7996 7.52488C11.4269 7.52488 11.1247 7.82708 11.1247 8.19986H12.4746ZM13.5996 5.49992V6.1749H14.2746V5.49992H13.5996ZM6.39974 5.49992H5.72475V6.1749H6.39974V5.49992ZM15.1965 10.6083L14.9604 12.3048L16.2975 12.4909L16.5336 10.7944L15.1965 10.6083ZM5.03894 12.3048L4.80284 10.6083L3.46576 10.7944L3.70186 12.4909L5.03894 12.3048ZM9.99967 18.3247C8.62345 18.3247 8.1326 18.3119 7.72742 18.1409L7.20257 19.3847C7.91994 19.6874 8.74471 19.6746 9.99967 19.6746V18.3247ZM3.70186 12.4909C3.95359 14.2997 4.09044 15.3112 4.39376 16.1368L5.66091 15.6712C5.42015 15.0159 5.30041 14.1836 5.03894 12.3048L3.70186 12.4909ZM7.72742 18.1409C6.89724 17.7906 6.1252 16.9349 5.66091 15.6712L4.39376 16.1368C4.9469 17.6423 5.9336 18.8492 7.20257 19.3847L7.72742 18.1409ZM14.9604 12.3048C14.6989 14.1836 14.5792 15.0159 14.3384 15.6712L15.6056 16.1368C15.9089 15.3112 16.0458 14.2997 16.2975 12.4909L14.9604 12.3048ZM9.99967 19.6746C11.2546 19.6746 12.0794 19.6874 12.7968 19.3847L12.2719 18.1409C11.8667 18.3119 11.3759 18.3247 9.99967 18.3247V19.6746ZM14.3384 15.6712C13.8741 16.9349 13.1021 17.7906 12.2719 18.1409L12.7968 19.3847C14.0657 18.8492 15.0524 17.6423 15.6056 16.1368L14.3384 15.6712ZM4.80284 10.6083C4.60293 9.17187 4.45366 8.09819 4.37175 7.23604L3.02783 7.36373C3.11317 8.26193 3.26745 9.36944 3.46576 10.7944L4.80284 10.6083ZM16.5336 10.7944C16.7319 9.36943 16.8862 8.26193 16.9715 7.36373L15.6276 7.23604C15.5457 8.09819 15.3964 9.17187 15.1965 10.6083L16.5336 10.7944ZM17.1995 4.82493H2.7998V6.1749H17.1995V4.82493ZM8.87469 15.3997V8.19986H7.52472V15.3997H8.87469ZM12.4746 15.3997V8.19986H11.1247V15.3997H12.4746ZM12.9246 4.59993V5.49992H14.2746V4.59993H12.9246ZM13.5996 4.82493H6.39974V6.1749H13.5996V4.82493ZM7.07472 5.49992V4.59993H5.72475V5.49992H7.07472ZM9.99967 1.67498C11.6151 1.67498 12.9246 2.98453 12.9246 4.59993H14.2746C14.2746 2.23896 12.3606 0.325016 9.99967 0.325016V1.67498ZM9.99967 0.325016C7.6387 0.325016 5.72475 2.23896 5.72475 4.59993H7.07472C7.07472 2.98453 8.38427 1.67498 9.99967 1.67498V0.325016Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="w-full relative">
                                    <Field
                                        as="textarea"
                                        name="message"
                                        rows="14"
                                        placeholder="Type a message here…"
                                        className="text-18 lg:text-20 py-3 lg:py-5 px-7 rounded-xl w-full bg-secondary outline-none"
                                    />
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`absolute bottom-6 right-6 w-14 xl:w-16 h-14 xl:h-16 bg-primary rounded-full shadow-2xl flex items-center justify-center ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {loading ? (
                                            <ClipLoader color="white" size={30} />
                                        ) : (
                                            <svg width="30" height="30" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.8371 0.116239C31.6946 -0.00609924 31.4919 -0.0344825 31.3201 0.0435481L0.276788 14.167C0.109661 14.243 0.00203754 14.4063 2.85693e-05 14.5867C-0.0019804 14.7672 0.102103 14.9327 0.267604 15.0122L9.05281 19.2339C9.21391 19.3114 9.40601 19.2939 9.54989 19.1886L18.0915 12.9373L11.386 19.6912C11.2903 19.7876 11.2415 19.9196 11.2521 20.0536L11.9197 28.5675C11.9345 28.7562 12.0637 28.9175 12.2473 28.9766C12.2963 28.9923 12.3468 29 12.3966 29C12.5333 29 12.6663 28.9426 12.7588 28.8377L17.4217 23.5468L23.186 26.2436C23.3111 26.3022 23.456 26.3046 23.5831 26.2505C23.7102 26.1962 23.807 26.0908 23.8486 25.9613L31.978 0.608684C32.0348 0.43164 31.9794 0.238578 31.8371 0.116239Z" fill="white" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="w-full lg:max-w-[370px]">
                    <div className="flex flex-wrap lg:block">
                        {tableData && tableData.length > 0 ? (
                            tableData.map((item, index) => (
                                <div
                                    key={index}
                                    className="w-full md:w-1/2 lg:w-full p-3.5 py-2.5" >
                                    <div className="p-6 bg-white rounded-2xl shadow-custom_shadow_2 space-y-3">
                                        <h3
                                            className="text-16 font-medium text-black cursor-pointer"
                                            onClick={() => fetchSendMessage(item?._id)}
                                        >
                                            {item.subject}
                                        </h3>
                                        <p className="text-text_2 text-14 font-normal line-clamp-3 break-words">{item.message}</p>
                                        <div className="flex flex-wrap">
                                            {item?.photo.map((image, index) => (
                                                <div key={index} className="w-[calc(100%/3)] md:w-[calc(100%/5)]" >
                                                    <div className="w-16 h-16 p-1">
                                                        <img src={image?.photo} className="w-full h-full object-cover rounded-xl overflow-hidden" alt="" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="flex justify-between items-center text-14">
                                            <button className="text-red font-semibold inline-block" onClick={() => handleDeleteClick(item._id)}>
                                                Delete
                                            </button>
                                            <span className="inline-block text-text_2">
                                                {item.date}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="w-full p-6 text-center text-18 xl:text-24 text-gray-500">No data found..!</div>
                        )}
                    </div>
                </div>
                <div className="w-full">
                    {pagination > 0 && (
                        <div className="flex justify-end items-center mt-4">
                            <Paginator
                                className="border-0"
                                first={first}
                                rows={limit}
                                totalRecords={pagination}
                                rowsPerPageOptions={[3, 6, 18, 36]}
                                onPageChange={(e) => {
                                    setLimit(e.rows);
                                    getGalleryListFun(e);
                                }}
                                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            />
                        </div>
                    )}
                </div>
            </div>
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </>
    );
};

export default Gallery;
